export const IDS = {

    pnpSettingsApprovalWorkflow: 'pnpSettingsApprovalWorkflow',
    pnpSettingsApprovalWorkflowGrid: 'pnpSettingsApprovalWorkflowGrid',
   
    // settings aproval workflow states :
    app_policies_settings_approval_workflows_add: 'app.policies.settings.approval_workflows.add',
    app_policies_settings_approval_workflows_add_details: 'app.policies.settings.approval_workflows.add.details',
    app_policies_settings_approval_workflows_manage: 'app.policies.settings.approval_workflows.manage',
    app_policies_settings_approval_workflows_manage_details: 'app.policies.settings.approval_workflows.manage.details',
    app_policies_settings_approval_workflows_manage_listing: 'app.policies.settings.approval_workflows.manage.listing',
};